import { Link } from 'react-router-dom';
import Container from '../components/layout/Container';
import Button from '../components/common/Button';
import './NotFound.css';

export function NotFound() {
  return (
    <Container className="not-found">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="not-found-actions">
          <Link to="/">
            <Button variant="primary" size="large">
              Go to Home
            </Button>
          </Link>
          <Link to="/competitions">
            <Button variant="secondary" size="large">
              Browse Competitions
            </Button>
          </Link>
        </div>
      </div>
    </Container>
  );
}

export default NotFound;
